/**
 * Styled components for field editing.
 *
 * These styled components are separated from AssignedToDropdown.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

import { FormControl, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "AssignedToDropdown";

export const classes = {
  formControl: `${PREFIX}-formControl`,
};

export const StyledFormControl = styled(FormControl)(
  ({ theme }: { theme: Theme }) => ({
    [`&.${classes.formControl}`]: {
      minWidth: 300,
      paddingBottom: theme.spacing(2),
    },
  })
);
